import React from 'react';
import { Container, Typography, Paper, Button } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';

export const CreditsCanceledPage: React.FC = () => {
  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Paper sx={{ p: 6, textAlign: 'center' }}>
        <CancelIcon sx={{ fontSize: 80, color: 'warning.main', mb: 3 }} />

        <Typography variant="h4" gutterBottom sx={{ fontWeight: 700 }}>
          Payment Canceled
        </Typography>

        <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>
          Your purchase was not completed.
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          No charges were made to your account. You can close this tab and return to the GovToolsPro extension to try again.
        </Typography>

        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={() => window.close()}
        >
          Close This Tab
        </Button>
      </Paper>
    </Container>
  );
};
